module.exports = __webpack_public_path__ + "img/banner-star-icon2.6d860cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/banner-star-icon2.png
// module id = z8Cp
// module chunks = 1